import { palette } from "./palette";
export var DarkTheme = {
    themeMode: 'dark',
    _palette: {
        colors: palette,
        graphics: {
            motivatorLevels: {
                needToHave: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                        {
                            offset: 0,
                            color: '#AFDDE7'
                        },
                        {
                            offset: 1,
                            color: '#19ACCC'
                        }
                    ],
                    global: false
                },
                niceToHave: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                        {
                            offset: 0,
                            color: '#B0B6B9'
                        },
                        {
                            offset: 1,
                            color: '#375170'
                        }
                    ],
                    global: false
                },
                neutral: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                        {
                            offset: 0,
                            color: '#5D7187'
                        },
                        {
                            offset: 1,
                            color: '#425870'
                        }
                    ],
                    global: false
                }
            }
        }
    },
    _components: {
        loading: {
            text: '',
            color: palette.hero[400],
            spinnerRadius: 16,
            showSpinner: true,
            maskColor: 'rgba(255, 255, 255, 0.8)',
            lineWidth: 2
        },
        barPercentageLabel: {
            m_percentage: {
                color: palette.hero[200]
            }
        },
        barAxisLabel: {
            backgroundColor: 'none',
            m_label: {
                color: palette.hero[200]
            }
        },
        scatterPlot: {
            bookend: {
                color: palette.hero[200]
            },
            categoryAxisLabel: {
                color: palette.primary[300]
            },
            valueAxisLabel: {
                color: palette.hero[200]
            },
            valueAxisPercentageLine: {
                color: palette.hero[300]
            },
            categoryAxisGuideLine: {
                color: palette.hero[300]
            }
        }
    }
};

//# sourceMappingURL=dark_theme.js.map